import { WorkflowEditorService } from 'api-clients/monolith';
import { useEffect, useState } from 'react';

// Derived from the generated client so the hook's shape can never drift from the OpenAPI spec
// for this endpoint (no hand-declared response type to keep in sync).
type RehireConnectorsResult = Awaited<
  ReturnType<
    typeof WorkflowEditorService.getInternalApiWorkflowEditorRehireCheckConnectors
  >
>;
export type RehireConnector = RehireConnectorsResult['connectors'][number];

let catalogPromise: Promise<RehireConnector[]> | null = null;

const fetchRehireConnectors = (): Promise<RehireConnector[]> => {
  if (!catalogPromise) {
    catalogPromise =
      WorkflowEditorService.getInternalApiWorkflowEditorRehireCheckConnectors()
        .then(response => response.connectors ?? [])
        .catch(() => {
          catalogPromise = null;
          return [];
        });
  }
  return catalogPromise;
};

export const resetRehireConnectorsCacheForTests = () => {
  catalogPromise = null;
};

export function useRehireConnectors(): {
  connectors: RehireConnector[];
  loading: boolean;
} {
  const [connectors, setConnectors] = useState<RehireConnector[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    void fetchRehireConnectors().then(catalog => {
      if (mounted) {
        setConnectors(catalog);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { connectors, loading };
}
